import { useTranslation } from '@pancakeswap/localization'
import { Table, Th } from '@pancakeswap/uikit'
import Container from 'components/Layout/Container'
import { PredictionUser } from 'state/types'
import styled from 'styled-components'
import DesktopRow from './DesktopRow'

const StyledCard = styled.div``

const StyledTh = styled(Th)`
  width: calc((100% - 52px) / 5);
  font-size: 14px;
  padding-right: 24px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  text-transform: none;
`

interface DesktopResultsProps {
  results: PredictionUser[]
}

const DesktopResults: React.FC<React.PropsWithChildren<DesktopResultsProps>> = ({ results }) => {
  const { t } = useTranslation()

  return (
    <Container mb="16px">
      <StyledCard>
        <TableStyle>
          <thead>
            <tr>
              <StyledTh style={{ paddingBottom: 0, paddingRight: '24px', paddingLeft: '0px', width: '76px' }}>
                Top
              </StyledTh>
              <StyledTh textAlign="left">{t('User')}</StyledTh>
              <StyledTh textAlign="left">{t('PnL')}</StyledTh>
              <StyledTh textAlign="left">{t('Win Rate')}</StyledTh>
              <StyledTh textAlign="left">{t('Rounds Won')}</StyledTh>
              <StyledTh textAlign="left">{t('Rounds Played')}</StyledTh>
            </tr>
          </thead>
          <tbody>
            {results.map((result, index) => (
              <DesktopRow key={result.id} rank={index + 4} user={result} />
            ))}
          </tbody>
        </TableStyle>
      </StyledCard>
    </Container>
  )
}
const TableStyle = styled(Table)`
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0 8px;
`
export default DesktopResults
